module.exports = __webpack_public_path__ + "img/nebi-profile.1e4c6ea6.jpg";